import Vue from 'vue';
import { TYPE_CONTRACT } from '@/aquassist-shared/constants/types/features';

const defaultState = () => ({
    team: {},
    selectedLang: null,
    teamDateFormat: null,
    showContractByFeature: false,
});

const mutations = {
    setTeamState(state, team) {
        Vue.set(state, 'team', team);
    },
    setShowContractByFeature(state, showContractByFeature) {
        state.showContractByFeature = showContractByFeature;
    },
    setSelectedLang(state, selectedLang) {
        Vue.set(state, 'selectedLang', selectedLang);
    },
    setTeamDateFormat(state, dateFormat) {
        Vue.set(state, 'teamDateFormat', dateFormat);
    },
    resetTeamState(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    async reloadTeam({ commit }, teamId) {
        try {
            const { data } = await this.$rq.getTeam(teamId);
            const isContractFeature = data.activeFeatures?.some(
                ({ feature }) => feature?.type === TYPE_CONTRACT,
            );
            commit('setShowContractByFeature', isContractFeature);
            commit('setTeamState', data);
            commit('setSelectedLang', data.lang);
            commit('setTeamDateFormat', data.dateFormat || null);
        } catch (err) {
            commit('resetTeamState');
        }
    },
    resetTeamInfo({ commit }) {
        commit('resetTeamState');
    },
    resetSelectedLang({ commit }) {
        commit('resetTeamState');
    },
};

const getters = {
    showContractByFeature: state => state.showContractByFeature,
    teamOptionalLangs: state => state.team.optionalLangs,
    selectedLang: state => state.selectedLang,
    teamMainLang: state => state.team.lang,
    teamDateFormat: state => state.team.dateFormat,
    allTeamLangs: state => {
        const { lang, optionalLangs } = state.team;
        const mainLang = {
            key: lang,
            optional: false,
        };
        const allLangs = [];
        allLangs.push(mainLang);
        if (optionalLangs) {
            optionalLangs.map(oLang => (
                allLangs.push({
                    key: oLang,
                    optional: true,
                })));
        }
        return allLangs;
    },
};


export default {
    state: defaultState(),
    getters,
    actions,
    mutations,
};
